var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-557 558.8 84.3 84.2",
    style: {
      enableBackground: "new -557 558.8 84.3 84.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-home-button{fill:#666666;}\n\t.st1-home-button{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.154458393513096, 42.1202761920784) scale(-1, 1) translate(-42.154458393513096, -42.1202761920784)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "st0-home-button",
    d: "M568.9,600.9c0,16.6,13.6,30.2,30.2,30.2c16.6,0,30.2-13.6,30.2-30.2 c0-16.6-13.6-30.2-30.2-30.2C582.5,570.7,568.9,584.3,568.9,600.9l30.2,27.2c15,0,27.2-12.2,27.2-27.2s-12.2-27.2-27.2-27.2 c-15,0-27.2,12.2-27.2,27.2s12.2,27.2,27.2,27.2L568.9,600.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "st0-home-button",
    d: "M599.1,560.9c22,0,40,18,40,40s-18,40-40,40c-22,0-40-18-40-40S577.1,560.9,599.1,560.9l0,79 c21.4,0,39-17.4,39-39c0-21.4-17.6-39-39-39c-21.4,0-39,17.6-39,39c0,21.4,17.4,39,39,39L599.1,560.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.154458393513096, 42.12027619207841) rotate(150.00005363462506) translate(-42.154458393513096, -42.12027619207841)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "st1-home-button",
    d: "M-129.9-720.3c0-17-13.8-30.8-30.8-30.8v4c14.6,0,26.6,12,26.6,26.6s-12,26.6-26.6,26.6 s-26.6-12-26.6-26.6c0-2.4,0.2-5,1-7.4l-4.2-1.2c-0.8,3-1.2,5.8-1.2,8.8c0,17,13.8,30.8,30.8,30.8S-129.9-703.3-129.9-720.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.30891678702619, 40.13069260064776) scale(-1, 1) translate(-42.30891678702619, -40.13069260064776)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    className: "st1-home-button",
    d: "M-514.7,584.8l-16,16h5.3V613h7.2v-7.2h6.6v7.2h7.2v-12.3h5.8L-514.7,584.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3d9425efd5b601a5d649f2915ae4e1f1.svg";
export { ForwardRef as ReactComponent };